import React, { useEffect, useState } from 'react';
// template components
import SuspectEmailCaptureForm from '@nmx/template/dist/componentLibrary/modules/SuspectEmailCaptureForm';
// utils
import hideSuspectEmailCapture from '../../../../../utils/hideSuspectEmailCapture/hideSuspectEmailCapture';

export default ({
  config,
  loadRecaptcha,
  setLoadRecaptcha,
}) => {
  const [hideForm, setHideForm] = useState(false);

  useEffect(() => {
    const res = hideSuspectEmailCapture();
    setHideForm(res);
  }, []);

  // if the user is part of a predetermined tealium audience or is an assigned client, hide the SEC form
  if(hideForm){
    return false;
  }

  return (
    <SuspectEmailCaptureForm
      sectionId='life-insurance-page-suspect-email-capture-form'
      formLocation='life-insurance'
      config={config}
      onFormEngaged={() => {
        if (!loadRecaptcha) {
          setLoadRecaptcha(true);
        }
      }}
      journey='selfSubscribeLifeAndMoneyNewsletter'
      position='static' // optional prop for analytics
    />
  );
};
